import { NativeDesktop } from "shared/native-desktop/NativeDesktopSupportShared";
import { NativeDesktopWindow } from "../../shared/native-desktop/NativeDesktopWindow";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export class NativeDesktopWindowRegistry {
  private desktop: NativeDesktop;
  private windowRegistry: { [key: string]: NativeDesktopWindow } = {};

  public constructor() {
    this.initialize();
  }

  protected initialize(): void {
    this.desktop = window["desktop"] as NativeDesktop;

    this.desktop.on("closed", this.onWindowClosed.bind(this));

    this.desktop.on("closing", this.onWindowClosing.bind(this));

    this.desktop.on("bounds-changed", this.onBoundsChanged.bind(this));

    let wnd = window as any;
    if (!wnd._openOverwritten) {
      wnd._open = window.open;
      wnd.open = this.captureWindowOpen.bind(this);
      wnd._openOverwritten = true;
    }
  }

  protected captureWindowOpen(url: string, name: string, params: string): Window {
    let wnd = window as any;

    if (this.windowRegistry[name] != null) {
      return this.windowRegistry[name].getNativeWindow();
    }

    let newWindow = wnd._open(url, name, params);
    let newDesktopWindow = new NativeDesktopWindow(newWindow);

    this.windowRegistry[name] = newDesktopWindow;

    return newWindow;
  }

  protected onWindowClosed(frameName: string): void {
    delete this.windowRegistry[frameName];
  }

  protected onWindowClosing(frameName: string): void {
    let wnd = this.windowRegistry[frameName];
    if (wnd?.onClose != null) {
      let close = true;
      try {
        close = wnd.onClose(wnd);
      } catch (e) {
        logger.out.error(
          `${this.constructor.name}: Error invoking onClose on window ${frameName}` +
            `, error: ${e}`,
          e,
        );
      }

      if (close) {
        wnd.preventClosing(false).then(() => {
          wnd.close();
        });
      }
    }
  }

  protected onBoundsChanged(frameName: string, event: any): void {
    let wnd = this.windowRegistry[frameName];
    if (wnd?.fireRestoreEvent != null) {
      wnd.fireRestoreEvent(event);
    }
  }

  public get(frameName: string) {
    return this.windowRegistry[frameName];
  }

  public findWindow(element: Element): NativeDesktopWindow {
    return Object.values(this.windowRegistry)
      .map((e) => e as NativeDesktopWindow)
      .find((e) => {
        return e.getNativeWindow() === element.ownerDocument.defaultView;
      });
  }

  public getAll(): NativeDesktopWindow[] {
    return Object.values(this.windowRegistry);
  }
}
